import { makeAutoObservable } from 'mobx'
import { RootStore } from '../rootStore'
import { IViewStatus } from '../../interface/progress.interface'
import { IInputStatus } from '../../interface/progress.interface'


class ProgressBar {

  rootStore: RootStore
  currentPercent: number = 5

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  baseProgress = () => {
    this.checkProgress()
  }

  checkProgress(): void {
    const { ProgressStore } = this.rootStore
    let newCurrentPercent = 5
    Object.keys(ProgressStore.stepsProgress).forEach((element) => {
      const step = ProgressStore.stepsProgress[element as any]
      if (step.viewStatus === IViewStatus.check) {
        newCurrentPercent += step.percent || 0
      }
      Object.keys(step.inputs).forEach(item => {
        if (step.inputs[item].status === IInputStatus.success) {
          newCurrentPercent += step.inputs[item].percent || 0
        }
      })
    });
    this.currentPercent = newCurrentPercent
  }

  progressTrigger = () =>  {
    this.checkProgress()
  }

}

export default ProgressBar
